// Split from the write step so callers can batch their layout reads into one pass.
export const readHeaderHeight = () => {
	const header = document.querySelector('.main-header');
	const adminBar = document.getElementById('wpadminbar');

	return {
		headerHeight: header ? header.offsetHeight : 0,
		adminBarHeight: adminBar ? adminBar.offsetHeight : 0,
	};
};

export const writeHeaderHeight = ({ headerHeight, adminBarHeight }) => {
	document.body.style.setProperty(
		'--header-height',
		`${(headerHeight + adminBarHeight) / 16}rem`
	);

	document.body.style.setProperty(
		'--admin-bar-height',
		`${adminBarHeight / 16}rem`
	);
};

const setHeaderHeight = () => {
	writeHeaderHeight(readHeaderHeight());
};

export default setHeaderHeight;
